import { Dispatch, SetStateAction } from 'react';
import NoData from '../../../../../../components/NoData';
import { SecondaryButton } from '../../../../../../components/SecondaryButton';
import useGetGeneralAppData from '../../../../../../hooks/useGetGeneralAppData';
import { Card } from './styles';

interface DateInfoCardI {
  startProcessDate?: string;
  endProcessDate?: string;
  processDuration: number;
  setFinishProcessModalShow: Dispatch<SetStateAction<boolean>>;
  checkingDate?: string;
}

export default function DateInfoCard({ startProcessDate, endProcessDate, processDuration, setFinishProcessModalShow, checkingDate }: DateInfoCardI) {
  const { isCustomer } = useGetGeneralAppData();

  return (
    <Card>
      <div className="card-title">
        <div>Datas e Duração</div>
      </div>

      {!!startProcessDate && (
        <>
          <div className="card-main" style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
            height: '100%',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <div style={{fontSize: '20px'}}>
                {startProcessDate}
              </div>
              <small>
                Data inicial do Processo
              </small>
            </div>

            {!!endProcessDate && (
              <>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                  <div style={{fontSize: '20px'}}>
                    {processDuration} {processDuration === 1 ? 'dia' : 'dias'}
                  </div>
                  <small>
                Duração do Processo
                  </small>
                </div>

                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                  {!!endProcessDate && (
                    <div style={{fontSize: '20px'}}>
                      {endProcessDate}
                    </div>
                  )}
                  <small>
                    Data Final do Processo
                  </small>
                </div>
              </>
            )}

            {(!endProcessDate && !isCustomer) && (
              <div style={{fontSize: '12px'}}>
                <SecondaryButton onClick={() => setFinishProcessModalShow(true)} disabled={!checkingDate}>
                  Finalizar Processo
                </SecondaryButton>
              </div>
            )}
          </div>
        </>
      )}

      {(!startProcessDate) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados sobre as datas de início, término e duração do processo
            </>
          )}
        />
      )}
    </Card>
  );
}
